import PropTypes from 'prop-types';

const Text = ({ children, center = false }) => (
  <p className={`max-w-xl leading-7 text-pj-gray-800 xxxs:text-lg sm:text-xl ${center && 'text-center'}`}>
    {children}
  </p>
);

Text.propTypes = {
  center: PropTypes.bool,
  children: PropTypes.node,
};

export default Text;
